import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfua-gallery gfu-gallery__slide" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_carousel_navigation = _resolveComponent("base-carousel-navigation")
  const _component_external_link = _resolveComponent("external-link")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_carousel_navigation, {
      type: "zoom",
      icon: "search-plus",
      class: "gfu-gallery__slide--action",
      onClick: $options.onZoom
    }, null, 8 /* PROPS */, ["onClick"]),
    ($props.url)
      ? (_openBlock(), _createBlock(_component_external_link, {
          key: $props.url,
          href: $props.url,
          onClick: _withModifiers($options.onZoom, ["prevent"])
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["href", "onClick"]))
      : _createCommentVNode("v-if", true)
  ]))
}